<template>
  <el-card
    shadow="always"
    :body-style="{ padding: '20px' }"
    v-loading="loading"
    class="card"
  >
    <div v-if="data" slot="header" class="clearfix">
      <div class="header">
        <div class="header__title">
          <span slot="reference">
            Балансы в RUB
          </span>
        </div>
        <div
          class="header__button"
          @mouseover="progressHovered = true"
          @mouseleave="progressHovered = false"
        >
          <div v-show="progressHovered">
            <el-button
              :disabled="!forceEnabled"
              type="primary"
              icon="el-icon-refresh"
              circle
              size="mini"
              @click="forceData"
            ></el-button>
          </div>
          <el-progress
            v-show="!progressHovered"
            :percentage="(remainedTime * 100) / refreshRate"
            type="circle"
            :width="28"
            :stroke-width="2"
            :format="pers => ``"
          ></el-progress>
        </div>
      </div>
    </div>
    <div class="content justify-start" v-if="data">
      <div>
        Всего: {{ data.total ? data.total.toFixed(2) : "N/A" }} RUB
      </div>
    </div>
    <div class="content justify-end">
      <div class="small" :class="{ 'error-text': loadError }">
        {{ updatedAgoReadable }}
        <span v-if="loadError">· ошибка обновления</span>
      </div>
    </div>
    <div class="content" v-if="!data && !loading">
      <div>
        Ошибка получения данных!
      </div>
    </div>
  </el-card>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "DashboardBiTotalInRubElement",
  data: () => ({
    refreshRate: 60 * 60 * 1000,
    interval: null,
    remainedInterval: null,
    remainedTime: 0,
    updatedAgo: 0,
    forceCooldownSeconds: 10,
    forceInterval: null,
    progressHovered: false,
    loadedAt: null,
    loadError: false
  }),
  computed: {
    ...mapState("ledgerBi", {
      data: state => state.ledgerBiTotalInRub,
      loading: state => state.loadingTotalInRub
    }),
    updatedAgoReadable() {
      if (!this.updatedAgo) return "N/A";
      return `${this.timeAgo(this.updatedAgo)}`;
    },
    forceEnabled() {
      return !this.forceCooldownSeconds;
    }
  },
  methods: {
    ...mapActions("ledgerBi", ["getLedgerBiTotalInRub"]),
    getAgo() {
      if (!this.loadedAt) return "N/A";
      const msAgo = this.$dayjs(new Date()).diff(this.$dayjs(this.loadedAt));
      return this.timeAgo(msAgo);
    },
    async getData() {
      if (this.interval) clearTimeout(this.interval);
      this.remainedTime = this.refreshRate;
      try {
        await this.getLedgerBiTotalInRub();
        this.loadError = false;
        this.loadedAt = new Date();
        this.updatedAgo = 0;
      } catch (error) {
        this.loadError = true;
      } finally {
        this.interval = setTimeout(this.getData, this.refreshRate);
      }
    },
    async forceData() {
      await this.getData();
    }
  },
  async mounted() {
    await this.getData();
    // this.interval = setTimeout(this.getData, this.refreshRate);
    this.remainedInterval = setInterval(() => {
      this.remainedTime -= 1000;
      this.updatedAgo += 1000;
    }, 1000);
    this.forceInterval = setInterval(() => {
      this.forceCooldownSeconds =
        this.forceCooldownSeconds <= 0 ? 0 : this.forceCooldownSeconds - 1;
    }, 1000);
  },
  beforeDestroy() {
    clearTimeout(this.interval);
    // clearInterval(this.interval);
    clearInterval(this.remainedInterval);
    clearInterval(this.forceInterval);
  }
};
</script>
<style scoped>
.card {
  min-width: 200px;
  width: 280px;
}
.content {
  display: flex;
  align-items: baseline;
}

.content .justify-center {
  justify-content: center;
}
.content .justify-end {
  justify-content: end;
}
.content .justify-start {
  justify-content: start;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.header__title {
  width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.header__button {
  height: 28px;
}
.small {
  /* margin-top: 1rem; */
  font-size: 0.65rem;
  margin-left: 0.2rem;
  color: rgba(0, 0, 0, 0.5);
}
.error-text {
  color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Ledger/components/Balances/Dashboard/ledgerBiTotalInRub.vue